import { v4 as uuid } from 'uuid';

/**
 * Numero massimo di suffissi numerici tentati prima di ripiegare su un
 * suffisso casuale.
 */
const MAX_NUMERIC_ATTEMPTS = 100;

/**
 * Ritorna un codice univoco a partire da `base`, rispetto ai codici gia'
 * presenti. Se `base` e' libero lo ritorna invariato; altrimenti appende un
 * suffisso numerico sequenziale (`base_1`, `base_2`, …) fino a trovarne uno
 * disponibile.
 *
 * Se dopo `MAX_NUMERIC_ATTEMPTS` tentativi non e' stato trovato un codice
 * libero, ripiega su un suffisso casuale (`base_<uuid>`) garantendo comunque
 * la terminazione in casi patologici.
 *
 * Quando `existingCodes` e' gia' un `Set` viene usato direttamente, senza
 * ricostruirlo: cosi' il chiamante puo' riusare lo stesso insieme in un loop
 * (aggiungendovi il codice restituito) senza costo quadratico.
 */
export function getUniqueCode(
  base: string,
  existingCodes: Iterable<string>,
): string {
  const used =
    existingCodes instanceof Set ? existingCodes : new Set(existingCodes);
  if (!used.has(base)) return base;

  for (let i = 1; i <= MAX_NUMERIC_ATTEMPTS; i++) {
    const candidate = `${base}_${i}`;
    if (!used.has(candidate)) return candidate;
  }

  return `${base}_${uuid().slice(0, 8)}`;
}
